import { defineStore } from "pinia";

export interface SnackBarState {
  show: boolean;
  message: string;
  title: string;
  color: "success" | "error";
  timeout: number;
  vertical: boolean;
}

export const useSnackBarStore = defineStore("snackBarStore", {
  state: (): SnackBarState => ({
    show: false,
    message: "",
    title: "",
    color: "success",
    timeout: 3000,
    vertical: false,
  }),

  actions: {
    showNotification(
      message: string,
      title: string,
      timeout: number,
      vertical: boolean,
      color: "success" | "error"
    ): void {
      this.message = message;
      this.title = title;
      this.timeout = timeout;
      this.vertical = vertical;
      this.color = color;
      this.show = true;
    },

    showSuccess(
      message: string = "Completed successfully",
      title: string = "",
      timeout: number = 3000,
      vertical: boolean = false
    ): void {
      this.showNotification(message, title, timeout, vertical, "success");
    },

    showError(
      message: string = "Operation failed",
      title: string = "",
      timeout: number = 3000,
      vertical: boolean = false
    ): void {
      this.showNotification(message, title, timeout, vertical, "error");
    },

    hide(): void {
      this.show = false;
      this.message = "";
      this.timeout = 3000;
      this.vertical = false;
    },
  },
});
